import React, {Component} from "react";
import '../../EMR.css';
import DateUtil from "../../../../../utils/DateUtil";
import TreatmentReceivedEnum from "../enums/treatmentrecieved/TreatmentReceivedEnum";
import {MultiSelect} from "primereact/multiselect";
import RedAsterisk from "../../../../../components/asterisk/RedAsterisk";
import {getClinicTimeZone} from "../../../../../utils/TimezoneUtil";

export default class TreatmentReceivedCptModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            procedureList: props.procedureList
        }
    }

    treatmentsChanged = (procedure, treatments) => {
        procedure.treatments = treatments;
        this.forceUpdate();
    }

    render() {
        const receivedTreatmentsWithData = TreatmentReceivedEnum.toArray()
            .filter(treatment => this.props.treatmentReceived[treatment.field]?.length > 0);
        const receivedTreatmentTexts = receivedTreatmentsWithData.map(t => t.key);
        const timeZone = getClinicTimeZone();
        return (
            <div>
                {receivedTreatmentsWithData.length <= 0 && <><RedAsterisk renderForAllTypes/> Please add treatment(s)
                    first</>}
                <div className={"content-card"}>
                    <table className={"emr-table"}>
                        <tbody>
                        <tr>
                            <th>Cpt Code</th>
                            <th>Time</th>
                            <th>Treatment Received</th>
                        </tr>
                        {this.state.procedureList?.length > 0 ?
                            this.state.procedureList.map((procedure, index) => {

                                const availableTreatments = procedure.treatments?.filter(t => receivedTreatmentTexts.includes(t));
                                return <tr key={"procedures" + index} style={{backgroundColor: "white"}}>
                                    <td><span
                                        className="font-weight-bold">{procedure.cpt.cptCode}</span> - {procedure.cpt.description}
                                    </td>
                                    <td className="text-nowrap"><span
                                        className="font-weight-bold">Start:</span> {DateUtil.getHourMinute24H(procedure.startTime, timeZone)} &nbsp;
                                        <span
                                            className="font-weight-bold">End:</span> {DateUtil.getHourMinute24H(procedure.endTime, timeZone)} &nbsp;
                                    </td>
                                    <td><MultiSelect value={availableTreatments}
                                                     options={receivedTreatmentsWithData}
                                                     optionLabel="name" optionValue="key"
                                                     disabled={receivedTreatmentsWithData.length <= 0}
                                                     placeholder={receivedTreatmentsWithData.length > 0 ? "Select..." : "N/A"}
                                                     onChange={e => this.treatmentsChanged(procedure, e.value)}/>
                                    </td>
                                </tr>
                            }
                            ) : "No cpts selected for billing in Diagnosis section"}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
